import { useCallback, useContext } from "react";
import { useQuery } from "react-query";

import { UseQueryProps } from "../../interfaces";
import { apiServiceContext } from "../../api-service-context";
import { QueryKeys } from "../query-keys";

export const useUserFilters = <TData = any, TError = any>(
  queryOptions: UseQueryProps<TData, TError> = {}
) => {
  const { filterApiService } = useContext(apiServiceContext);
  const queryFn = useCallback(
    () =>
      filterApiService.createCancellableRequest((cancelToken) =>
        filterApiService.getUserFilters(cancelToken)
      ),
    [filterApiService]
  );

  return useQuery(QueryKeys.userFilters(), queryFn, queryOptions);
};
